/*
 * Logging configuration and factory functions.
 *
 * This implementation uses the loglevel library.
 * https://github.com/pimterry/loglevel
 *
 * This module also offers some simple formatting functions for friendly-looking log messages.
 *
 */

import loglevel from 'loglevel';

/**
 * Obtains the logger for a given category.
 *
 * Clients should use this as the primary means of obtaining a logger.
 *
 * @param category
 */
export const getLogger = (category) => loglevel.getLogger(category);
